export default __webpack_public_path__ + "static/section4_feature1-b4a716bebd42365fa459b50ff0d7298f.png";